module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-hr-4-80c690d577af8d00c78974fb86c03b41.png";